export default __webpack_public_path__ + "static/media/bB.e1a52add.svg";